import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Box,
    Breadcrumbs,
    Link as MUILink,
    Typography,
    IconButton,
    Grid,
    Card,
    CardActionArea,
    CardContent
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import SchemaIcon from '@mui/icons-material/Schema';
import RuleIcon from '@mui/icons-material/Rule';
import { AuthContext } from '../contexts/AuthContext';

export default function WorkflowDashboard() {
    const { features } = useContext(AuthContext);
    const navigate = useNavigate();

    const gotToWorkflowAdmin = () => {
        navigate('/workflow/admin');
    }

    const gotToWorkflowEditor = () => {
        navigate('/workflow/editorlist');
    }

    const gotToWorkflowRules = () => {
        navigate('/workflow/rules');
    }

    // Close button navigates back.
    const handleClose = () => {
        navigate(-1);
    };

    return (
        <Container sx={{ mt: 2 }}>
            {/* Breadcrumb */}
            <Box sx={{ mb: 1 }}>
                <Breadcrumbs aria-label="breadcrumb">
                    <MUILink underline="hover" color="inherit" onClick={() => navigate('/')}>
                        Home
                    </MUILink>
                    <Typography color="text.primary">Workflows</Typography>
                </Breadcrumbs>
            </Box>

            {/* Page Header */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {/* Changed from HomeIcon to a document icon */}
                    <SchemaIcon sx={{ fontSize: 48, mr: 1 }} />
                    <Box>
                        <Typography
                            variant="h4"
                            sx={{ fontWeight: 'bold', fontSize: 24 }}  // Set header font size to 24px
                        >
                            Workflows
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            sx={{ color: 'text.secondary', fontSize: 12 }}  // Set subtitle font size to 12px
                        >
                            Manage workflows
                        </Typography>
                    </Box>
                </Box>
                {/* X to close */}
                <IconButton onClick={handleClose} sx={{ fontSize: 24 }}>
                    <CloseIcon sx={{ fontSize: 24 }} />
                </IconButton>
            </Box>

            {/* Action Tiles */}
            <Box sx={{ mb: 4 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            {features?.includes('Design Workflows') && (
                                <Grid item xs={6} sm={4} md={3}>
                                    <Card>
                                        <CardActionArea onClick={gotToWorkflowEditor}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
                                                <SettingsIcon sx={{ fontSize: 48, color: '#B74140' }} />
                                                <CardContent>
                                                    <Typography variant="h6" align="center">
                                                        Editor
                                                    </Typography>
                                                </CardContent>
                                            </Box>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )}
                            {features?.includes('Audit Workflows') && (
                                <Grid item xs={6} sm={4} md={3}>
                                    <Card>
                                        <CardActionArea onClick={gotToWorkflowAdmin}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
                                                <SchemaIcon sx={{ fontSize: 48, color: '#B74140' }} />
                                                <CardContent>
                                                    <Typography variant="h6" align="center">
                                                        Status
                                                    </Typography>
                                                </CardContent>
                                            </Box>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )}
                            {features?.includes('Manage rules') && (
                                <Grid item xs={6} sm={4} md={3}>
                                    <Card>
                                        <CardActionArea onClick={gotToWorkflowRules}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
                                                <RuleIcon sx={{ fontSize: 48, color: '#B74140' }} />
                                                <CardContent>
                                                    <Typography variant="h6" align="center">
                                                        Rules
                                                    </Typography>
                                                </CardContent>
                                            </Box>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};
